<div class="list-wrapper">
  @for (referral of referrals; track referral.id) {
    <div class="item" (click)="onReferralClick(referral)">
      <div class="left-side">
        @if (selectionEnabled) {
          <label
            nz-checkbox
            [nzChecked]="selectedReferralIds.has(referral.id)"
            (click)="$event.stopPropagation()"
            (nzCheckedChange)="onItemCheck(referral.id, $event)"
          ></label>
        }
        <ng-container>
          <app-user-avatar
            class="hidden md:inline-block"
            [size]="56"
            [avatarUrl]="getAvatarUrl(referral?.avatar?.image)"
            [initials]="getReferralInitials(referral)"
            [profileColor]="referral?.profile_color"
          />
          <app-user-avatar
            class="md:hidden"
            [size]="40"
            [avatarUrl]="getAvatarUrl(referral?.avatar?.image)"
            [initials]="getReferralInitials(referral)"
            [profileColor]="referral?.profile_color"
          />
        </ng-container>
        <div class="user-info">
          <span class="paragraph-medium font-medium inline-block name"
            >{{ referral.first_name }} {{ referral.last_name }}</span
          >
          @if (!hideFeatures) {
            <span class="paragraph-medium regular inline-block reminderCount">{{ getReminderCount(referral) }}</span>
          }
        </div>
      </div>
      <div class="right-side flex justify-center items-center gap-2">
        <div class="paragraph-medium regular hidden sm:inline-block referral-contact-date">
          {{ 'referral.referredOn' | translate }}
          {{ getLastContactedDate(referral.timestamp) }}
        </div>
        <i nz-icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M5.64644 13.1868C5.45118 12.9915 5.45118 12.675 5.64644 12.4797L10.1262 7.99992L5.64644 3.52012C5.45118 3.32485 5.45118 3.00832 5.64644 2.81305C5.8417 2.61779 6.15829 2.61779 6.35355 2.81305L11.1869 7.64639C11.3821 7.84165 11.3821 8.15819 11.1869 8.35345L6.35355 13.1868C6.15829 13.3821 5.84171 13.3821 5.64644 13.1868Z"
              fill="#505760"
            />
          </svg>
        </i>
      </div>
    </div>
  }
</div>
